import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';

import { useTranslation } from 'react-i18next';

// style
import styles from './style';

// components
import Modal from '../../../components/modal/Modal';
// img
import legendRainfallMonth from '../../../assets/images/legend_rainfallMonth.png';

const useStyles = makeStyles(styles);

export default function RainfallLegendMonth() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [modalData, setModalData] = useState({
    open: false,
    header: t('เกณฑ์'),
    subheader: null,
    content: null,
  });
  const unmounted = useRef(false);

  const handleModal = () => (e) => {
    e.preventDefault();

    setModalData({
      open: true,
      header: t('เกณฑ์ฝนสะสมรายเดือน'),
      content: <Grid item xs align="center"><img src={legendRainfallMonth} alt={t('เกณฑ์ฝนสะสม 7 วัน')} /></Grid>,
    });
  };

  function FormRow() {
    return (
      <>
        <Grid item xs>
          <FormControl className={classes.formControl}>
            <Button id="rain-monthly-legend-btn" variant="outlined" color="primary" size="small" className={classes.button} onClick={handleModal()} title={t('แสดงเกณฑ์')}>
              {t('แสดงเกณฑ์ฝนรายเดือน')}
            </Button>
          </FormControl>
        </Grid>
        <Modal
          open={modalData.open}
          modalHeader={modalData.header}
          modalSubHeader={modalData.subheader}
          modalContent={modalData.content}
        />
      </>
    );
  }

  // force modal close
  useEffect(() => {
    if (modalData.open) modalData.open = false;
    return () => { unmounted.current = true; };
  }, [modalData.open]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <FormRow />
      </Grid>
    </div>
  );
}
